export const formatToLocaleString = (value: string | number, options?: Intl.NumberFormatOptions) =>
  Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, ...options });
